export const drawerWidth = 64;
export const drawerOpenWith = 250;
export const HEIGHT_TOP_BAR = "64px";
